<template>
  <div class="gangan">
    <div class="contentGansu">
      <div class="right">
        <div class="titleTop">版权服务</div>
        <div class="info">前海版权综合服务平台提供版权登记、版权预登记、软件著作权登记、电子数据存证、网页取证、版权监测、法律服务、版权交易等多维度版权服务，为用户提供一站式的版权综合服务平台，从而更全面更规范、更好的服务广大版权人、创作者。</div>
        <div class="mapBox">
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">版权登记</div>
            </div>
            <div class="item">版权登记服务，指由权利人申请，通过前海版权综合服务平台，与版权局对接实现的在线方式的版权登记服务，申请人通过在线方式将需要登记作品相关的著作权人身份信息、版权相关信息、版权证明文件及作品样本等按照在线数字版权登记的标准要求提交给版权局，通过审核后核准登记，并下发电子版作品登记证书。</div>
            <div class="title2">办理周期及版权服务费用：</div>
            <div class="item1" :class="index+1 == priceList.length?'bot':''" v-for="(item,index) in priceList" :key="index">
              {{item.remarks}}：{{(item.bizPrice / 100).toFixed(2)}}元/次
            </div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">版权预登记</div>
            </div>
            <div class="item">申请人仅需提交作品即完成预登记，当作品需要登记时再另行提交登记申请所获作品登记证书的登记时间以预登记时间为准。原创作品一旦经创作即确权服务确权，其确权证书上的作品完成时间、作品发表时间、作品登记时间将被版权局的版权登记系统认可，权利人可以在任何时间申请版权局的版权登记证书，登记证书上的作品完成日期、作品发表日期、登记日期与确权证书一致。</div>
            <div class="title2" style="margin-bottom: 36px;">版权预登记服务费用：{{(yudengji.bizPrice / 100).toFixed(2)}}元/次</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">软件著作权登记</div>
            </div>
            <div class="item">软件著作权登记服务，指由用户填写相关服务信息，前海版权综合服务平台运营人员将根据用户填写的信息进行联系，为用户提供软件著作权登记服务。</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">电子数据存证</div>
            </div>
            <div class="item">电子数据存证服务，指由权利人申请，通过前海版权综合服务平台，将权利人提供的信息，经授时服务器由版权区块链联盟进行记录存证，并对权利人的版权交易服务进行存证的服务。</div>
            <div class="title2" style="margin-bottom: 36px;">电子数据存证服务费用：{{(yudengji2.bizPrice / 100).toFixed(2)}}元/次</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">网页取证</div>
            </div>
            <div class="item">网页截屏取证是前海版权综合服务平台提供的取证服务，主要是为了解决用户取证需求，以及用户公证取证费用高，网络取证证据无法固定，网络取证后不具有法律效力等多个问题。取证功能适合内容为文字和图片的静态网页取证。只需用户输入网页URL地址，系统即可自动将网址进行网页截屏采集并存储为图片数据上传至区块链进行证据固化保全，同时将数据同步至互联网法院，从而帮助用户固化侵权、违法信息，实现快速维权。取证结束后可在个人中心-我的取证列表中查看网页取证详细信息，并可在订单列表中下载取证证书、证据包等取证生成文件，同时支持证书核验功能。网页取证收费是按照每次取证的目标网址条数进行计费。</div>
            <div class="title2" style="margin-bottom: 36px;">网页取证服务费用：{{(yudengji3.bizPrice / 100).toFixed(2)}}元/条</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">法律服务</div>
            </div>
            <div class="item"  style="margin-bottom: 36px;">法律服务，指前海版权综合服务平台同第三方律师事务所、公证处、仲裁局、反侵权联盟、内容平台等合作或者委托，为权利人提供打击和制止版权侵权、索回损失、法律诉讼等服务。</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">版权监测</div>
            </div>
            <div class="item"  style="margin-bottom: 36px;">版权监测服务，指前海版权综合服务平台提供的对于指定的作品或者作品集合在互联网网络上的发布、阅读、播放、转载、素材使用等情况的信息收集和统计分析服务。前海版权综合服务提供的监测报告只代表提供监测结果时监测到的情况，此报告不具备任何法律效力。</div>
          </div>
          <div class="list">
            <div class="titleM">
              <img class="dian" src="../assets/aboutUs/dian.png" alt="">
              <div class="text">IP授权</div>
            </div>
            <div class="item"  style="margin-bottom: 36px;">版权交易服务主要为用户提供IP展示、IP授权和交易的功能。在“IP授权”板块中，将对企业客户提供基于标签体系的IP查找过滤功能，供客户查找适合自己的IP，深入理解IP内容，了解IP授权内容。用户可以通过微信小程序或者Web网站直接申请授权合作，平台运营人员将第一时间与用户取得联系。</div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import {gerBzPriceOfCopyrightRegister} from "@/api/staticPage";
import {configGetBzPrice} from "@/api/index.js";
    export default {
      name: "ganan_gangan",
      data(){
        return {
          priceList: [],
          yudengji: {},
          yudengji2: {},
          yudengji3: {}
        }
      },
			components: {
			},
      mounted() {
        this.gerBzPriceOfCopyrightRegister()
        this.configGetBzPrice()
      },
      methods: {
        gerBzPriceOfCopyrightRegister() {
          gerBzPriceOfCopyrightRegister().then( res => {
            this.priceList = res.result
          })
        },
        async configGetBzPrice() {
          let data1 = {
            bizType: '17',
            subBizType: '1701'
          }
          let res1 = await configGetBzPrice(data1)
          this.yudengji = res1.result
          let data2 = {
            bizType: '01',
            subBizType: '0102',
          }
          let res2 = await configGetBzPrice(data2)
          this.yudengji2 = res2.result
          console.log(res2);
          let data3 = {
            bizType: '03',
            subBizType: '0301',
          }
          let res3 = await configGetBzPrice(data3)
          this.yudengji3 = res3.result
      },
      },
			watch: {
				$route(to, from) {

				}
			}
    };
</script>

<style lang="less" scoped>
.contentGansu{
  .right{
    .titleTop{
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 18px;
      font-family: AlibabaPuHuiTi;
    }
    .info{
      font-size: 14px;
      line-height: 16px;
      margin: 30px 0 36px 0;
    }
    .mapBox{
      .titleM{
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 12px;
        .dian{
          width: 24px;
          margin-right: 8px;
        }
        .text{
          font-family: AlibabaPuHuiTi;
        }
      }

      .item{
        font-size: 14px;
        margin-bottom: 15px;
      }
      .title2{
        font-size: 14px;
        font-weight: 600;
        font-family: AlibabaPuHuiTi;
      }
      .item1{
        font-size: 14px;
        margin-top: 10px;
      }
      .bot{
        margin-bottom: 36px;
      }
      .map{
        margin-top: 35px;
      }
      .xiangmuBox{
        display: flex;
        justify-content: space-between;
        .boxItem{
          border-radius: 8px;
          padding: 24px;
          border: 1px solid #E5E5E5;
          flex: 0 0 294px;
          .imgBox{
            display: flex;
            align-items: center;
            font-size: 16px;
            color: #666;
            .iocn{
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
          }
          .msgBox{
            display: flex;
            align-items: center;
            font-size: 14px;
            color: #999;
            margin-top: 13px;
            .msg{
              margin-right: 15px;
              &:last-child{
                margin-right: 0;
              }
            }
          }
        }
      }
      .lianxiBox{
        margin-top: 39px;
        margin-bottom: 15px;

      }
      .itemlianxi{
        margin-bottom: 12px;
        a{
          color: #333;
        }
      }
    }
  }
}

</style>
